export function isObject(value: unknown): boolean {
	return value !== null && typeof value === "object" && !(value instanceof Date);
}
